/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FieldError } from "react-hook-form";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { Box } from "./Box";
import { COLORS } from "./constants";

type Props = {
  value: string;
  onChange: (value: string) => void;
  error?: FieldError | undefined;
};

export function ColorPicker({ value, onChange, error }: Props) {
  const isError = error ? theme.colors.danger : "";

  return (
    <FlexContainer css={{ marginLeft: `-${theme.spacing.spacing01}` }}>
      {COLORS.map((color: string, idx: number) => (
        <Box
          key={color}
          data-testid={`color-${idx}`}
          inline
          color={color}
          margin={`0 ${theme.spacing.spacing01}`}
          size={theme.spacing.spacing08}
          aria-label={color}
          onClick={() => {
            onChange(color);
          }}
          border={isError}
          css={{
            opacity: value === color ? 1 : 0.3,
          }}
        />
      ))}
    </FlexContainer>
  );
}
